import { call, put, takeEvery } from 'redux-saga/effects'

import { PAPER_ELEMENT_TYPE } from '../../../shared/constants/drawable-types'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Select, Workspace } from '../../lib/toolBoxes/2D'
import { multiSelectDrawables, setMultiSelectingDrawableType } from '../../slices/2D'
import { setHighlightPopupColor } from '../../slices/common'

export function* handleMultiSelectingMaterial({ payload }: ReturnType<typeof multiSelectDrawables>) {
    const paperManager: PaperManager | null = yield call(managers.get2DManager)

    if (!paperManager) return

    if (payload.length === 0) {
        const [selectTool]: [Select] = yield call(paperManager.getTools, [Select.NAME])

        yield call(selectTool.clearAllMultiSelections, false)

        return
    }

    const workspaceTool: Workspace = yield call(paperManager.getTool, Workspace.NAME)

    // Unlock all items when multiselecting to allow hover interaction
    yield call(workspaceTool.lockItems, false)

    const items: paper.Item[] = yield call(workspaceTool.getItemsWithCriteria, 'data', (data) =>
        payload.includes(data.opening_location_id)
    )

    if (!(items.length > 0)) return

    // A modification can share its opening_location_id with a hidden base material, so items[0]
    // isn't reliable -- prefer a modification match if one is present.
    const modificationItem = items.find(
        (item) =>
            item.data?.type === PAPER_ELEMENT_TYPE.MODIFICATION ||
            item.data?.type === PAPER_ELEMENT_TYPE.MODIFICATION_TO_EDIT
    )

    yield put(setMultiSelectingDrawableType((modificationItem ?? items[0]).data?.type || null))

    if (items[0].data?.type === PAPER_ELEMENT_TYPE.HIGHLIGHT) {
        yield put(setHighlightPopupColor(items[0].fillColor?.toCSS(true) || null))
    }
}

export function* watchForMultiSelectingMaterial() {
    yield takeEvery(multiSelectDrawables.type, handleMultiSelectingMaterial)
}
